module.exports = __webpack_public_path__ + "media/images/admin/icons/skip-back-81ad9f15ef0d6c32e4136678a1c0f81a.svg";